import { render, staticRenderFns } from "./BusinessSection.vue?vue&type=template&id=c28cda08&scoped=true"
import script from "./BusinessSection.vue?vue&type=script&lang=js"
export * from "./BusinessSection.vue?vue&type=script&lang=js"
import style0 from "./BusinessSection.vue?vue&type=style&index=0&id=c28cda08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28cda08",
  null
  
)

export default component.exports